var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconTypeAttachment = function SvgMiconTypeAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "m28.1 18.9-15-15c-2.5-2.6-6.6-2.6-9.2-.1s-2.6 6.7 0 9.2l.1.1L6.8 16l1.4-1.4-2.9-2.9c-1.7-1.7-1.7-4.6 0-6.3s4.6-1.8 6.3-.1l.1.1 14.9 14.9c1.8 1.7 1.8 4.6.1 6.3-1.7 1.8-4.6 1.8-6.3.1l-.1-.1-7.4-7.4c-1-1-.9-2.6 0-3.5 1-.9 2.5-.9 3.5 0l4.1 4.1 1.4-1.4-4.2-4.2c-1.8-1.7-4.6-1.6-6.3.2-1.6 1.7-1.6 4.4 0 6.2l7.5 7.5c2.5 2.6 6.6 2.6 9.2.1s2.6-6.7 0-9.3c0 0 0 .1 0 0"
  })));
};
export default SvgMiconTypeAttachment;